<template>
  <div class="addAquestionMain">
    <!-- <span class="el-icon-house"> / 赛事中心 / 题目管理 / 试卷题目</span> -->
    <div class="backStyle">
      <el-page-header content="试卷题目" @back="goback"></el-page-header>
    </div>
    <div class="addAquestionTopic">
      <div style="font-weight: bold;font-size: 16px;">试卷题目</div>
      <div style="margin-top: 20px;">
        <el-form :inline="true" :model="formInline" size="mini">
          <el-form-item label="题目名称">
            <el-input
              style="width:200px;"
              @keyup.enter.native="search"
              v-model="formInline.title"
              placeholder="请输入题目名称"
              clearable
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="知识点">
                        <el-select @change="search" v-model="formInline.question_tag_id" placeholder="请选择" clearable>
                            <el-option v-for="item in options1" :key="item.id" :label="item.title" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="search">查询</el-button>
            <el-button
              size="mini"
              type="primary"
              @click="addQuestion"
              :disabled="$route.query.educational_institution_id != null"
              >添加题目</el-button
            >
          </el-form-item>

          <el-button
            style="float:right"
            size="mini"
            v-if="isShow == false ? true : false"
            @click="changeAll"
            >展开全部</el-button
          >
          <el-button
            style="float:right"
            @click="changeAll1"
            size="mini"
            v-if="isShow == true ? true : false"
            >全部收起</el-button
          >

          <br />

          <el-form-item label="题目类型">
            <el-radio-group @change="search" v-model="formInline.type">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">单选题</el-radio>
              <el-radio label="2">多选题</el-radio>
              <el-radio label="3">判断题</el-radio>
              <el-radio label="4">填空题</el-radio>
              <el-radio label="5">简答题</el-radio>
              <el-radio label="6">综合题</el-radio>
              <el-radio label="7">阅读程序</el-radio>
              <el-radio label="8">完善程序</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item>
                        <el-button>重置</el-button>
                    </el-form-item> -->
        </el-form>
      </div>

      <div>
        <el-table
          size="small"
          :row-key="(row) => row.id"
          :expand-row-keys="expandedRows"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }"
          stripe
          :data="tableData"
          style="width: 100%;margin-top: 0px;"
        >
          <el-table-column type="expand">
            <template slot-scope="props">
              <div v-if="props.row.questionInfo.show_type === 1">
                <div
                  class="question_title"
                  v-html="props.row.questionInfo.title"
                ></div>
              </div>
              <div class="question_title" v-else>
                <mavon-editor
                  :style="{ 'min-height': '0px' }"
                  preview-background="#fff"
                  v-model="props.row.questionInfo.title_md"
                  defaultOpen="preview"
                  :boxShadow="false"
                  :editable="false"
                  :subfield="false"
                  :toolbarsFlag="false"
                ></mavon-editor>
              </div>

              <div v-if="props.row.questionInfo.show_type === 1">
                <div
                  class="options"
                  v-for="(item, index) of JSON.parse(
                    props.row.questionInfo.options
                  )"
                  :key="index"
                >
                  <div v-if="props.row.questionInfo.type != '6'">
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content" v-html="item.content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="props.row.questionInfo.type == '3'">
                  <div
                    class="options"
                    v-for="(item, index) of JSON.parse(
                      props.row.questionInfo.options
                    )"
                    :key="index"
                  >
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content" v-html="item.content"></div>
                    </div>
                  </div>
                </div>
                <div
                  v-else
                  class="options"
                  v-for="(item, index) of JSON.parse(
                    props.row.questionInfo.options_md
                  )"
                  :key="index"
                >
                  <div v-if="item.content" class="options_title">
                    {{ item.title }}
                  </div>

                  <div v-if="item.content" class="options_content">
                    <div class="content">
                      <mavon-editor
                        :style="{ 'min-height': '0px' }"
                        preview-background="#F5F7FC"
                        v-model="item.content"
                        defaultOpen="preview"
                        :boxShadow="false"
                        :editable="false"
                        :subfield="false"
                        :toolbarsFlag="false"
                      ></mavon-editor>
                    </div>
                  </div>
                </div>
              </div>
              <div style="margin-top: 10px;">
                <div class="answer_label">正确答案:</div>
                <div
                  v-if="
                    props.row.questionInfo.type == '1' ||
                      props.row.questionInfo.type == '2' ||
                      props.row.questionInfo.type == '3' ||
                      props.row.questionInfo.type == '4' ||
                      props.row.questionInfo.type == '7' ||
                      props.row.questionInfo.type == '8'
                  "
                  class="answer_content"
                  v-html="props.row.questionInfo.answer"
                ></div>
                <div v-else-if="props.row.questionInfo.type == '5'">
                  简答题答案
                </div>
                <div v-else-if="props.row.questionInfo.type == '6'">
                  综合题答案
                </div>
              </div>

              <div style="margin-top: 10px;">
                <div class="answer_label">试题解析:</div>
                <div
                  v-if="props.row.questionInfo.show_type === 1"
                  class="answer_content"
                  v-html="props.row.questionInfo.analysis"
                ></div>
                <div v-else class="answer_content">
                  <mavon-editor
                    :style="{ 'min-height': '0px' }"
                    preview-background="#fff"
                    v-model="props.row.questionInfo.analysis_md"
                    defaultOpen="preview"
                    :boxShadow="false"
                    :editable="false"
                    :subfield="false"
                    :toolbarsFlag="false"
                  ></mavon-editor>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">{{
              scope.$index + 1 + page_size * (page_no - 1)
            }}</template>
          </el-table-column>
          <el-table-column label="题型">
            <template slot-scope="scope">
              <span v-if="scope.row.questionInfo.type == 1">单选</span>
              <span v-if="scope.row.questionInfo.type == 2">多选</span>
              <span v-if="scope.row.questionInfo.type == 3">判断</span>
              <span v-if="scope.row.questionInfo.type == 4">填空</span>
              <span v-if="scope.row.questionInfo.type == 5">简答</span>
              <span v-if="scope.row.questionInfo.type == 6">综合题</span>
              <span v-if="scope.row.questionInfo.type == 7">阅读程序</span>
              <span v-if="scope.row.questionInfo.type == 8">完善程序</span>
            </template>
          </el-table-column>
          <el-table-column
            label="题目名称"
            prop="questionInfo.title_str"
            show-overflow-tooltip
            width="160"
          >
          </el-table-column>
          <el-table-column label="知识点">
            <template slot-scope="scope">
              <span>{{ scope.row.questionInfo.tagTitleStr }}</span>
            </template>
          </el-table-column>
          <el-table-column label="分值" prop="score"> </el-table-column>
          <el-table-column label="题库信息">
            <template slot-scope="scope">
              <span
                style="cursor: pointer; color: #409EFF;"
                @click="showDetails(scope.row)"
                >详情</span
              >
            </template>
          </el-table-column>

          <el-table-column label="Code" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.questionInfo.code_other">
                {{ scope.row.questionInfo.code_other.substring(0, 4) }}</span
              >
              <span v-else>--</span>
            </template>
          </el-table-column>

          <el-table-column label="排序号" prop="sort_num"> </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-link
                type="primary"
                :disabled="
                  scope.row.questionInfo.educational_institution_id != null
                "
                @click="editBox(scope.row)"
                >编辑</el-link
              >
              <el-link
                style="margin-left: 10px;"
                :disabled="
                  scope.row.questionInfo.educational_institution_id != null
                "
                type="primary"
                @click="del(scope.row)"
                >删除</el-link
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <el-drawer
      size="100%"
      :visible.sync="drawer"
      :with-header="false"
      direction="ltr"
    >
      <div style="padding:10px;border-bottom:1px solid #f5f7fa;">
        <span style="font-weight: bold;font-size:18px;">添加题目</span>
        <el-button @click="CloseDrawer" style="float:right" size="mini"
          >✕</el-button
        >
      </div>

      <div style="padding: 20px;">
        <el-form :inline="true" :model="formInline1" size="mini">
          <el-form-item label="题目名称">
            <el-input
              style="width: 400px;"
              @keyup.enter.native="search1"
              v-model="formInline1.title_str"
              placeholder="请输入题目名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search1">查询</el-button>
            <el-button @click="Reset">重置</el-button>
          </el-form-item>

          <br />

          <el-form-item label="年份">
            <el-select
              @change="search1"
              style="width: 130px;"
              v-model="formInline1.year_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in testQuestionBankYearList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="题目来源">
            <el-select
              @change="changesource"
              v-model="formInline1.source_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in testQuestionBankSourceList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赛道/分项">
            <el-select
              @change="search1"
              :disabled="isShow3"
              v-model="formInline1.source_tag_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in testQuestionBankSourceTagList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="所属科目">
            <el-select
              @change="changeSubject"
              style="width: 130px;"
              v-model="formInline1.subject_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in subject_list"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="知识分组">
            <el-select
              :disabled="isShow1"
              @change="adminGetTestQuestionTagList"
              v-model="formInline1.question_group_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in testQuestionTagGroupList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="知识点">
            <el-select
              :disabled="isShow1"
              @change="search1"
              style="width: 130px;"
              v-model="formInline1.question_tag_id"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in testQuestionTagList"
                :key="item.id"
                :label="item.title"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <br />
          <el-form-item label="题目类型">
            <el-radio-group @change="search1" v-model="formInline1.type">
              <el-radio label="">全部</el-radio>
              <el-radio label="1">单选题</el-radio>
              <el-radio label="2">多选题</el-radio>
              <el-radio label="3">判断题</el-radio>
              <el-radio label="4">填空题</el-radio>
              <el-radio label="5">简答题</el-radio>
              <el-radio label="6">综合题</el-radio>
              <el-radio label="7">阅读程序</el-radio>
              <el-radio label="8">完善程序</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <el-table
          :data="tableData1"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#606266',
            'font-size': '14px',
          }"
          stripe
          style="width: 100%;"
          size="small"
        >
          <el-table-column prop="sort_num" label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (page_no - 1) * page_size }}
            </template>
          </el-table-column>

          <el-table-column prop="subjectName" label="科目" width="100">
          </el-table-column>
          <el-table-column prop="" label="题型" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.type == 1">单选</span>
              <span v-if="scope.row.type == 2">多选</span>
              <span v-if="scope.row.type == 3">判断</span>
              <span v-if="scope.row.type == 4">填空</span>
              <span v-if="scope.row.type == 5">简答</span>
              <span v-if="scope.row.type == 6">综合题</span>
              <span v-if="scope.row.type == 7">阅读程序</span>
              <span v-if="scope.row.type == 8">完善程序</span>
            </template>
          </el-table-column>
          <el-table-column label="题目名称" show-overflow-tooltip width="160">
            <template slot-scope="scope">
              <div v-html="scope.row.title_str"></div>
            </template>
          </el-table-column>
          <el-table-column align="center" prop="tagTitleStr" label="知识点">
          </el-table-column>

          <el-table-column prop="bankInfo.sourceTitle" label="来源">
          </el-table-column>
          <el-table-column prop="bankInfo.tagRelationTitleStr" label="分项">
          </el-table-column>

          <el-table-column prop="bankInfo.yearTitle" label="年份" width="100">
          </el-table-column>
          <el-table-column label="操作" width="100">
            <tempalte slot-scope="scope">
              <el-button type="text" size="mini" @click="Preview(scope.row)"
                >预览</el-button
              >
              <el-button
                type="text"
                size="mini"
                style="margin-left: 10px;"
                @click="addpaper(scope.row)"
                >添加</el-button
              >
            </tempalte>
          </el-table-column>
        </el-table>
        <div style="text-align: right;margin-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="page_no"
            layout="total, prev, pager, next"
            :total="total"
            :page-size="page_size"
          ></el-pagination>
        </div>
      </div>
    </el-drawer>
    <el-drawer size="50%" :visible.sync="drawer1" :with-header="false">
      <div style="padding: 20px;">
        <div style="font-weight: bold;font-size: 14px;">题目预览</div>
      </div>
      <div
        style="width: 100%;border-top: 1px solid #ccc; height: 1px;margin: 10px 0;"
      ></div>
      <div style="margin-top: 10px;padding: 20px;">
        <div style="border: 1px solid #ccc; border-radius: 5px;padding: 10px;">
          <div style="font-weight: bold;font-size: 14px;">题目题干</div>
          <div style="margin-top: 10px;">
            <div v-if="questionRow.show_type === 1">
              <div class="question_title" v-html="questionRow.title"></div>
            </div>
            <div class="question_title" v-else>
              <mavon-editor
                :style="{ 'min-height': '0px' }"
                preview-background="#fff"
                v-model="questionRow.title_md"
                defaultOpen="preview"
                :boxShadow="false"
                :editable="false"
                :subfield="false"
                :toolbarsFlag="false"
              ></mavon-editor>
            </div>
          </div>
          <div>
            <div v-if="questionRow.show_type === 1">
              <div
                class="options"
                v-for="(item, index) of JSON.parse(questionRow.options)"
                :key="index"
              >
                <div v-if="questionRow.type != '6'">
                  <div v-if="item.content" class="options_title">
                    {{ item.title }}
                  </div>

                  <div v-if="item.content" class="options_content">
                    <div class="content" v-html="item.content"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-if="questionRow.type == '3'">
                <div v-if="questionRow.options">
                  <div
                    class="options"
                    v-for="(item, index) of JSON.parse(questionRow.options)"
                    :key="index"
                  >
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content" v-html="item.content"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div v-if="questionRow.options_md">
                  <div
                    class="options"
                    v-for="(item, index) of JSON.parse(questionRow.options_md)"
                    :key="index"
                  >
                    <div v-if="item.content" class="options_title">
                      {{ item.title }}
                    </div>

                    <div v-if="item.content" class="options_content">
                      <div class="content">
                        <mavon-editor
                          :style="{ 'min-height': '0px' }"
                          preview-background="#fff"
                          v-model="item.content"
                          defaultOpen="preview"
                          :boxShadow="false"
                          :editable="false"
                          :subfield="false"
                          :toolbarsFlag="false"
                        ></mavon-editor>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top: 10px;">
            <div class="answer_label">正确答案:</div>
            <div
              v-if="
                questionRow.type == '1' ||
                  questionRow.type == '2' ||
                  questionRow.type == '3' ||
                  questionRow.type == '4'
              "
              class="answer_content"
              v-html="questionRow.answer"
            ></div>
            <div v-else-if="questionRow.type == '5'">简答题答案</div>
            <div v-else-if="questionRow.type == '6'">综合题答案</div>
          </div>

          <div style="margin-top: 10px;">
            <div class="answer_label">试题解析:</div>
            <div
              v-if="questionRow.show_type === 1"
              class="answer_content"
              v-html="questionRow.analysis"
            ></div>
            <div v-else class="answer_content">
              <mavon-editor
                :style="{ 'min-height': '0px' }"
                preview-background="#fff"
                v-model="questionRow.analysis_md"
                defaultOpen="preview"
                :boxShadow="false"
                :editable="false"
                :subfield="false"
                :toolbarsFlag="false"
              ></mavon-editor>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <div class="editDialog">
      <el-dialog
        title="编辑题目"
        :visible.sync="dialogVisible"
        width="500px"
        :before-close="handleClose1"
      >
        <el-form label-width="80px" :model="formLabelAlign">
          <el-form-item label="排序号">
            <el-input-number
              style="width:350px;"
              size="small"
              v-model="formLabelAlign.num"
              :precision="1"
              :step="0.1"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="题目分值">
            <el-input-number
              style="width:350px;"
              size="small"
              v-model="formLabelAlign.score"
              :precision="1"
              :step="0.1"
            >
              <template slot="append">分</template>
            </el-input-number>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitScore">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="editDialog">
      <el-dialog title="题库信息" :visible.sync="dialogVisible1" width="500px">
        <div style="font-weight: bold;">
          <ul>
            <li>
              年份 <span style="margin-left: 10px;"> {{ yearTitle }} </span>
            </li>
            <li style="margin-top: 15px;">
              来源
              <span style="margin-left: 10px;">
                {{ title }}
              </span>
            </li>
            <li style="margin-top: 15px;">
              分项
              <span
                style="margin-left: 10px;"
                v-if="questionBankInfo.tagRelationInfoArr"
              >
                <span
                  v-for="(item, index) in questionBankInfo.tagRelationInfoArr"
                  :key="index"
                >
                  {{ item.tagInfo.title }}
                </span>
              </span>
            </li>
            <li style="margin-top: 15px;">
              题库名称
              <span style="margin-left: 10px;">{{
                questionBankInfo.title
              }}</span>
              <!-- <span style="color: #47AFFF;cursor: pointer;margin-left: 10px;">立即前往</span> -->
            </li>
          </ul>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  adminGetCheckPaperQuestionList,
  adminGetTestQuestionListForPaperAddQu,
  adminGetTestQuestionBankSourceTagListWithoutPage, //分项
  adminGetTestQuestionBankSourceListWit, //来源
  adminGetTestQuestionBankYearListWithoutPage, //年份
  adminGetTestQuestionTagListWithoutPage, //知识点
  getSubjectList,
  adminAddQuestionToPaper,
  adminDeleteQuestionFromPaper,
  adminUpdatePaperQuestionScore,
  adminGetQuestionBankInfo,
  adminGetTestQuestionTagGroupListWithoutPage,
  adminGetTestQuestionTagList,
} from '@/api/admin.js'
export default {
  data() {
    return {
      isShow3: true,
      isShow1: true,
      isShow2: true,
      testQuestionTagGroupList: [],
      yearTitle: '',
      title: '',
      questionBankInfo: {},

      subject_list: [],
      options1: [],
      options: [
        {
          id: '1',
          title: '单选',
        },
        {
          id: '2',
          title: '多选',
        },
        {
          id: '3',
          title: '判断',
        },
        {
          id: '4',
          title: '填空',
        },
        {
          id: '5',
          title: '简答题',
        },
        {
          id: '6',
          title: '综合题',
        },
        {
          id: '7',
          title: '阅读程序题',
        },
        {
          id: '8',
          title: '完善程序题',
        },
      ],
      testQuestionTagList: [],
      testQuestionBankYearList: [],
      testQuestionBankSourceList: [],
      testQuestionBankSourceTagList: [],
      questionRow: {},
      dialogVisible1: false,
      formLabelAlign: {
        num: 0,
        score: '',
      },
      dialogVisible: false,
      drawer1: false,
      formInline1: {
        question_group_id: '',
        subject_id: '',
        question_tag_id: '',
        type: '',
      },
      tableData1: [],
      drawer: false,
      isShow: false,
      optionsType: [
        {
          id: 1,
          title: '单选',
        },
        {
          id: 2,
          title: '多选',
        },
        {
          id: 3,
          title: '判断',
        },
        {
          id: 4,
          title: '填空',
        },
        {
          id: 5,
          title: '简答',
        },
        {
          id: 6,
          title: '综合题',
        },
        {
          id: 7,
          title: '程序阅读',
        },
        {
          id: 8,
          title: '完善程序',
        },
      ],
      formInline: {
        title: '',
        value: '',
        type: '',
      },
      tableData: [],
      page_no: 1,
      page_size: 20,
      total: 0,
      expandedRows: [],
    }
  },

  mounted() {
    this.adminGetCheckPaperQuestionList()
    this.adminGetTestQuestionTagList()
  },
  methods: {
    //查询知识点
    adminGetTestQuestionTagList() {
      adminGetTestQuestionTagList({
        title: '',
        group_id: this.formInline1.question_group_id,
        page_no: 1,
        page_size: 1000,
      }).then((res) => {
        console.log('知识点')
        console.log(res)
        this.testQuestionTagList = res.TestQuestionTagList

        if (this.testQuestionTagList.length > 0) {
          this.isShow2 = false
        }
      })
    },

    //关闭选题窗口
    CloseDrawer() {
      console.log('关闭选题窗口')
      this.drawer = false
    },

    changesource(val) {
      if (val == '') {
        this.isShow3 = true
      } else {
        this.isShow3 = false
      }
      this.formInline1.source_id = val
      this.search1()
      this.adminGetTestQuestionBankSourceTagListWithoutPage()
    },
    //来源
    adminGetTestQuestionBankSourceListWit() {
      adminGetTestQuestionBankSourceListWit().then((res) => {
        console.log(res, 78945612)
        this.testQuestionBankSourceList = res.testQuestionBankSourceList
      })
    },
    //来源分项
    adminGetTestQuestionBankSourceTagListWithoutPage() {
      adminGetTestQuestionBankSourceTagListWithoutPage({
        source_id: this.formInline1.source_id,
      }).then((res) => {
        this.testQuestionBankSourceTagList = res.testQuestionBankSourceTagList
      })
    },
    changequestion(val) {
      if (val == '') {
        this.isShow2 = true
      } else {
        this.isShow2 = false
      }
      this.formInline1.question_group_id = val
      this.adminGetTestQuestionTagListWithoutPage()
    },
    changeSubject(val) {
      if (val == '') {
        this.isShow1 = true
        this.isShow2 = true
        this.formInline1.question_group_id = ''
        this.formInline1.question_tag_id = ''
      } else {
        this.isShow1 = false
      }
      console.log(val, 78974465)
      this.formInline1.subject_id = val
      this.adminGetTestQuestionTagGroupListWithoutPage()
      this.search1()
    },
    adminGetTestQuestionTagGroupListWithoutPage() {
      adminGetTestQuestionTagGroupListWithoutPage({
        subject_id: this.formInline1.subject_id,
      }).then((res) => {
        console.log(res, 798465)
        this.testQuestionTagGroupList = res.testQuestionTagGroupList
      })
    },
    goback() {
      this.$router.push({
        name: 'testPaper',
      })
    },
    //知识点
    adminGetTestQuestionTagListWithoutPage1() {
      alert('调用了', this.$route.query.subject_id)
      adminGetTestQuestionTagListWithoutPage({
        subject_id: this.$route.query.subject_id,
      }).then((res) => {
        console.log(res, 789655)
        this.options1 = res.testQuestionTagList
      })
    },
    submitScore() {
      adminUpdatePaperQuestionScore({
        paperQuestionId: this.formLabelAlign.id,
        score: this.formLabelAlign.score,
        sort_num: this.formLabelAlign.num,
      }).then((res) => {
        console.log(res, 78446)
        this.$message({
          type: 'success',
          message: '编辑成功!',
        })
        this.adminGetCheckPaperQuestionList()
      })
      this.dialogVisible = false
    },
    del(row) {
      this.$confirm('是否确认删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          adminDeleteQuestionFromPaper({
            paperId: this.$route.query.paper_id,
            paperQuestionId: row.id,
          }).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功!',
            })
            this.adminGetCheckPaperQuestionList()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },

    addpaper(row) {
      console.log(row, 78945665)
      adminAddQuestionToPaper({
        paperId: this.$route.query.paper_id,
        questionId: row.id,
      }).then(() => {
        this.adminGetTestQuestionListForPaperAddQu()
        this.$message.success('添加成功')
        this.adminGetCheckPaperQuestionList()
      })
    },

    adminGetCheckPaperQuestionList() {
      adminGetCheckPaperQuestionList({
        title: this.formInline.title,
        // question_tag_id: this.formInline.question_tag_id,
        type: this.formInline.type,
        paper_id: this.$route.query.paper_id,
      }).then((res) => {
        this.tableData = res.paperQuestionList
        console.log(res, 789465143)
      })
    },
    handleClose2() {
      this.dialogVisible1 = true
    },
    editBox(row) {
      console.log(row.score, 78645456)
      this.formLabelAlign.num = row.sort_num
      this.formLabelAlign.score = row.score
      this.formLabelAlign.id = row.id
      this.dialogVisible = true
    },

    Preview(row) {
      this.questionRow = row
      console.log(this.questionRow, 1235456)
      this.drawer1 = true
    },

    search1() {
      this.page_no = 1
      this.adminGetTestQuestionListForPaperAddQu()
    },
    handleCurrentChange(val) {
      console.log(val, 152456)
      this.page_no = val
      this.adminGetTestQuestionListForPaperAddQu()
    },
    adminGetTestQuestionListForPaperAddQu() {
      adminGetTestQuestionListForPaperAddQu({
        paperId: this.$route.query.paper_id,
        title_str: this.formInline1.title_str,
        source_id: this.formInline1.source_id,
        source_tag_id: this.formInline1.source_tag_id,
        year_id: this.formInline1.year_id,
        subject_id: this.formInline1.subject_id,
        question_tag_id: this.formInline1.question_tag_id,
        type: this.formInline1.type,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log(res, 78456)
        this.tableData1 = res.questionList
        this.total = res.total
      })
    },
    addQuestion() {
      this.drawer = true
      this.adminGetTestQuestionListForPaperAddQu()
      this.adminGetTestQuestionBankSourceListWit()
      this.adminGetTestQuestionBankYearListWithoutPage()
      // this.adminGetTestQuestionTagListWithoutPage()
      this.getSubjectList()
    },
    getSubjectList() {
      getSubjectList({
        page_no: 1,
        page_size: 100,
      }).then((res) => {
        this.subject_list = res.subject_list
      })
    },
    adminGetTestQuestionTagListWithoutPage() {
      adminGetTestQuestionTagListWithoutPage().then((res) => {
        console.log(res, 78945645665)
        this.testQuestionTagList = res.testQuestionTagList
      })
    },
    //年份
    adminGetTestQuestionBankYearListWithoutPage() {
      adminGetTestQuestionBankYearListWithoutPage().then((res) => {
        console.log(res, 963333)
        this.testQuestionBankYearList = res.testQuestionBankYearList
      })
    },

    Reset() {
      this.formInline1.title_str = ''
      this.formInline1.source_id = ''
      this.formInline1.source_tag_id = ''
      this.formInline1.subject_id = ''
      this.formInline1.year_id = ''
      this.formInline1.question_tag_id = ''
      this.formInline1.type = ''
      this.search1()
    },
    search() {
      this.adminGetCheckPaperQuestionList()
    },
    changeAll() {
      this.isShow = true
      this.expandedRows = this.tableData.map((row) => row.id)
    },
    changeAll1() {
      this.isShow = false
      this.expandedRows = []
    },

    handleClose() {
      this.drawer = false
    },
    handleClose1() {
      this.dialogVisible = false
    },
    showDetails(row) {
      console.log(row)
      adminGetQuestionBankInfo({
        questionBankId: row.questionInfo.quesiont_bank_id,
      }).then((res) => {
        console.log(res, 7894654156)
        this.questionBankInfo = res.questionBankInfo
        if (this.questionBankInfo.sourceInfo) {
          this.title = this.questionBankInfo.sourceInfo.title
        }
        this.yearTitle = this.questionBankInfo.yearTitle
      })
      this.dialogVisible1 = true
    },
  },
}
</script>

<style lang="scss" scoped>
.backStyle {
  // width:100%;
  padding: 10px;
  background: #fff;
  border-radius: 5px;
}

.addAquestionMain {
  padding: 10px;
}

.answer_content {
  margin-top: 10px;
}

.answer_label {
  font-weight: bold;
}

.options_title {
  border-radius: 50%;
  background: #fff;
  float: left;
  text-align: center;
  width: 35px;
  height: 35px;
  line-height: 34px;
  margin: 15px 0 15px 15px;
}

.content {
  margin: 15px 0 15px 0px;
}

.options_content {
  float: left;
  margin-left: 10px;
  line-height: 35px;
}

.question_title {
  font-weight: bold;
  font-size: 16px;
  color: #919499;
}

.options {
  overflow: hidden;
  width: 100%;
  //padding: 15px;
  border-radius: 5px;
  background-color: #f5f7fc;
  margin-top: 15px;
  box-sizing: border-box;
}

.addAquestionTopic {
  margin-top: 10px;
  background: white;
  border-radius: 5px;
  min-height: calc(100vh - 135px);
  width: 100%;
  padding: 25px;
  box-sizing: border-box;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

/deep/ .v-note-wrapper {
  border: 0px;
}

/deep/ .v-note-wrapper .v-note-panel .v-note-show .v-show-content,
.v-note-wrapper .v-note-panel .v-note-show .v-show-content-html {
  padding: 0;
}
</style>
<style>
.addAquestionMain .el-drawer__header {
  margin-bottom: 0px;
}

.editDialog .el-form--label-top .el-form-item__label {
  padding: 0;
}

.editDialog .el-form-item {
  margin-bottom: 0;
}
</style>
